import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIText1 } from '@cian/ui-kit';
import { IconActionFullscreen16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './CianLayout.css';
import { Gallery } from './components/Gallery';

export interface ICianLayoutProps {
  imageUrl: string;
  onShownInViewport(): void;
  onFullscreenLayoutOpen(): void;
}

export const CianLayout: React.FC<React.PropsWithChildren<ICianLayoutProps>> = ({
  imageUrl,
  onShownInViewport,
  onFullscreenLayoutOpen,
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = React.useState(false);
  const imageAlt = 'Планировка этой квартиры по данным Циан';

  const openGallery = React.useCallback(() => {
    setIsGalleryOpen(true);
    onFullscreenLayoutOpen();
  }, [onFullscreenLayoutOpen]);

  const handleGalleryClose = React.useCallback(() => {
    setIsGalleryOpen(false);
  }, []);

  return (
    <ActionAfterViewObserver callback={onShownInViewport} triggerOnce>
      <div className={styles['container']}>
        <div className={styles['header']}>
          <UIText1 display="block" fontWeight="bold">
            Планировка этой квартиры
          </UIText1>
          <UIText1 color="gray40_100">По данным Циан</UIText1>
        </div>
        <div className={styles['body']}>
          <img className={styles['image']} src={imageUrl} alt={imageAlt} onClick={openGallery} />
          <button
            className={styles['fullscreen-button']}
            aria-label="Открыть планировку на весь экран"
            onClick={openGallery}
          >
            <IconActionFullscreen16 color="icon-main-default" />
          </button>
        </div>
        {isGalleryOpen && <Gallery imageUrl={imageUrl} imageAlt={imageAlt} onClose={handleGalleryClose} />}
      </div>
    </ActionAfterViewObserver>
  );
};

CianLayout.displayName = 'CianLayout';
